import { Component, Input } from '@angular/core';

@Component({
  selector: 'web-components-snackbar-msg',
  templateUrl: './snackbar-msg.component.html',
  imports: [],
})
export class SnackbarMsgComponent {
  @Input() public msg: string;
  @Input() public msgDetail: string;
}
